import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { connect } from 'react-redux';
import {
  addComment,
  changeStatus,
} from '@pingum/app-state-management/event/actions';

import { grey } from '../../utils/brandColors';
import { getChipForTags } from '../../utils/tagsHelper';
import styles from './styles';
import StatusAssignment from '../StatusAssignment';

const noChangeStatus = {
  id: -1,
  name: 'Comment',
  iconColor: grey[300],
  icon: 'comment',
  requireComment: false,
};

export class ChangeStatusDialogComponent extends React.Component {
  constructor(props) {
    super(props);

    this.noChangeStatus = noChangeStatus;

    this.state = {
      selectedStatus: this.noChangeStatus,
      comment: '',
      assignment: '',
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open && this.props.selectedEvent
      && this.props.selectedEvent.currentEventStatus && this.props.selectedEvent.currentEventStatus.assignment) {
      // if current status has assignment, carry that over to the next status by default
      this.setState({ assignment: this.props.selectedEvent.currentEventStatus.assignment });
    }
  }

  handleClose = () => {
    this.setState({
      selectedStatus: this.noChangeStatus,
      comment: '',
      assignment: '',
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    });
    this.props.handleClose();
  }

  handleSelectedStatusChange = (selectedStatus) => {
    if (selectedStatus.id === this.props.selectedEvent.currentEventStatus.status.id) {
      return;
    }
    this.setState({
      selectedStatus,
      isValidStatus: true,
    });
  }

  handleWorkflowStatusChange = (workflowStatus) => {
    this.setState({
      workflowStatus,
      isValidAssignment: true,
    });
  }

  handleCommentChange = (e) => {
    const comment = e.target.value;
    const { requireComment } = this.state.selectedStatus;
    this.setState({
      comment,
      isValidStatus: !(requireComment && comment.trim().length === 0),
    });
  }

  handleAssignmentChange = (newUsers) => {
    const { workflowStatus } = this.state;

    this.setState({
      assignment: newUsers,
      isValidAssignment: !workflowStatus || !workflowStatus.requiredAssignment || !!newUsers,
    });
  }

  handleUpdateClick = () => {
    let allValid = true;
    if (this.state.selectedStatus.requireComment && this.state.comment.trim().length === 0) {
      this.setState({ isValidStatus: false });
      allValid = false;
    }
    if (this.state.workflowStatus && this.state.workflowStatus.requiredAssignment && !this.state.assignment) {
      this.setState({ isValidAssignment: false });
      allValid = false;
    }
    if (!allValid) {
      return false;
    }

    if (this.state.comment && this.state.selectedStatus.id < 0) {
      return this.props.addComment(
        this.props.selectedEvent.id,
        { comment: this.state.comment },
        this.handleClose,
      );
    }

    return this.props.changeStatus(
      this.props.selectedEvent.id,
      {
        statusId: this.state.selectedStatus.id,
        statusComment: this.state.comment,
        completeEvent: this.state.selectedStatus.endingStatus,
        assignment: this.state.assignment || null,
      },
      this.handleClose,
    );
  }

  canUpdate = () => (this.state.selectedStatus.id > -1 || this.state.comment || !this.state.isValidStatus)

  render() {
    const {
      classes,
      isLoading,
      selectedEvent,
      barnHorsesMap,
      locationsMap,
    } = this.props;
    const {
      comment,
      assignment,
      selectedStatus,
      isValidStatus,
      isValidAssignment,
    } = this.state;

    return (selectedEvent // <Dialog
    //   open={this.props.open}
    //   fullWidth
    //   maxWidth="md"
    //   onClose={this.handleClose}
    //   aria-labelledby="copy-dialog-title"
    //   aria-describedby="copy-dialog-description"
    // ></Dialog>
    && (
      <Box>
        <DialogTitle id="copy-dialog-title">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography>Change Task Status</Typography>
            {getChipForTags(selectedEvent.tags, barnHorsesMap, locationsMap)}
          </Box>

        </DialogTitle>
        <DialogContent className={classes.contentContainer}>
          <StatusAssignment
            allowNoStatusChange
            showCurrentStatusBanner
            showStatusCommentField
            comment={comment}
            assignment={assignment}
            selectedStatus={selectedStatus}
            event={selectedEvent}
            eventStatus={selectedEvent.currentEventStatus}
            isValidStatus={isValidStatus}
            isValidAssignment={isValidAssignment}
            handleSelectedStatusChange={this.handleSelectedStatusChange}
            handleWorkflowStatusChange={this.handleWorkflowStatusChange}
            handleAssignmentChange={this.handleAssignmentChange}
            handleCommentChange={this.handleCommentChange}
          />
        </DialogContent>
        <DialogActions className={classes.contentContainer}>
          <Button onClick={this.handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <div className={classes.updateButtonContainer}>
            <Button
              size="small"
              color="primary"
              disabled={!this.canUpdate() || isLoading}
              onClick={this.handleUpdateClick}
              variant="contained"
            >
              Update
            </Button>
            {
            isLoading
            && (
              <CircularProgress
                size={24}
                className={classes.updateProgress}
              />
            )
          }
          </div>
        </DialogActions>
      </Box>
    ));
  }
}

ChangeStatusDialogComponent.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  selectedEvent: PropTypes.object,
  handleClose: PropTypes.func,
  isLoading: PropTypes.bool,
  addComment: PropTypes.func,
  changeStatus: PropTypes.func,
  barnHorsesMap: PropTypes.object,
  locationsMap: PropTypes.object,
};

ChangeStatusDialogComponent.defaultProps = {
  classes: {},
  open: false,
  selectedEvent: {},
  handleClose: () => { },
  isLoading: false,
  addComment: () => { },
  changeStatus: () => { },
  barnHorsesMap: {},
  locationsMap: {},
};

export const mapStateToProps = (state) => ({
  isLoading:
    state.event.isAddingComment
    || state.event.isChangingStatus,
  barnHorsesMap: state.barn.barnHorsesMap,
  locationsMap: state.location.locationsMap,
});

export const mapDispatchToProps = (dispatch) => ({
  addComment: (id, comment, successCallback) => dispatch(addComment(id, comment, successCallback)),
  changeStatus: (id, status, successCallback) => dispatch(changeStatus(id, status, successCallback)),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeStatusDialogComponent));
